import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchDraughPeriode, fetchTrackDraughtPeriode } from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget } from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import CatDraugh from "./catdraugh";
import IconSettings from "@material-ui/icons/Settings";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import { pushLoader } from "../../actions/main";
import ReactExport from "assets/libs/react-export-excel";
import moment from "moment";
import { TextField } from "@material-ui/core";
import { withRouter } from "react-router-dom";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Draught Change ${moment().format("LLL")}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  }
});

let delay = null

class Draugh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      loader: null,
      selectedPeriode: "1",
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      totalData: 100,
      searchCheck: null,
      keyword: null,
      sort: ['none', 'none', 'none', 'none', 'none', 'none', 'none', 'desc', 'none'],
      orderby: `date_created`,
      activeColumn: 7,
      displayStatus: [false, true, true, true, false, true, true, true, true]
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    // fetchDraughPeriode(this.state.selectedPeriode)
    //   .then(response => {
    //     if (response != null) {
    //       response.data.results.map(e => {
    //         data.push({
    //           id: e.id,
    //           ship_id: e.ship_id,
    //           vessel_name: e.vessel_name,
    //           destination: e.destination,
    //           prev_destination: e.prev_destination,
    //           reported_draught: e.reported_draught,
    //           prev_reported_draught: e.prev_reported_draught,
    //           date_created: moment(e.date_created).format("DD/MM/YYYY H:mm:ss"),
    //           prev_date_created: moment(e.prev_date_created).format(
    //             "DD/MM/YYYY H:mm:ss"
    //           )
    //         });
    //       });
    //       this.setState({ datatable: data });
    //     }
    //     this.props.pushLoader(false);
    //     this.setState({ loader: false });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    this.handleSearch(10, 0)
  }

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleperiode = e => {
    this.setState({ selectedPeriode: e.target.value });

    let data = [];
    fetchDraughPeriode(e.target.value)
      .then(response => {
        if (response != null) {
          response.data.results.map(e => {
            data.push({
              id: e.id,
              ship_id: e.ship_id,
              vessel_name: e.vessel_name,
              destination: e.destination,
              prev_destination: e.prev_destination,
              reported_draught: e.reported_draught,
              prev_reported_draught: e.prev_reported_draught,
              date_created: moment(e.date_created).format("DD/MM/YYYY H:mm:ss"),
              prev_date_created: moment(e.prev_date_created).format(
                "DD/MM/YYYY H:mm:ss"
              )
            });
          });
          this.setState({ datatable: data });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleKeyword = async(e) => {
    await this.setState({ keyword: e })
    await this.handleSearch(10, 0)
  }

  handleSearch = (rows, page) => {
    this.setState({ loader: true, datatable: [] });
    let data = [];
    fetchTrackDraughtPeriode(
      this.state.startDate, 
      this.state.endDate, 
      rows, 
      rows * page, 
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : ''
    )
      .then((response) => {
        if (response != null) {
          response.data.results.map((e) => {
            data.push({
              id: e.id,
              ship_id: e.ship_id,
              vessel_name: e.vessel_name,
              destination: e.destination,
              prev_destination: e.prev_destination,
              reported_draught: e.reported_draught,
              prev_reported_draught: e.prev_reported_draught,
              date_created: moment(e.date_created).format(
                "DD/MM/YYYY H:mm:ss"
              ),
              prev_date_created: moment(e.prev_date_created).format(
                "DD/MM/YYYY H:mm:ss"
              ),
            });
          });
          this.setState({ datatable: data });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false, totalData: response.data.total });
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleSearchClick = async() => {
    await this.setState({ sort: ['none', 'none', 'none', 'none', 'none', 'none', 'none', 'desc', 'none'],
    orderby: `date_created`, activeColumn: 7 });
    this.handleSearch(10, 0);
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: this.state.displayStatus[0],
          sortDirection: this.state.sort[0]
        }
      },
      {
        name: "ship_id",
        label: "Ship Id",
        options: {
          filter: false,
          display: this.state.displayStatus[1],
          sortDirection: this.state.sort[1]
        }
      },
      {
        name: "vessel_name",
        label: "Vessel Name",
        options: {
          filter: false,
          display: this.state.displayStatus[2],
          sortDirection: this.state.sort[2]
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: false,
          display: this.state.displayStatus[3],
          sortDirection: this.state.sort[3]
        }
      },
      {
        name: "prev_destination",
        label: "Prev Destination",
        options: {
          filter: false,
          display: this.state.displayStatus[4],
          sortDirection: this.state.sort[4]
        }
      },
      {
        name: "reported_draught",
        label: "Reported Draught",
        options: {
          filter: false,
          display: this.state.displayStatus[5],
          sortDirection: this.state.sort[5]
        }
      },
      {
        name: "prev_reported_draught",
        label: "Prev Reported Draught",
        options: {
          filter: false,
          display: this.state.displayStatus[6],
          sortDirection: this.state.sort[6]
        }
      },
      {
        name: "date_created",
        label: "Date Created",
        options: {
          filter: false,
          display: this.state.displayStatus[7],
          sortDirection: this.state.sort[7]
        }
      },
      {
        name: "prev_date_created",
        label: "Prev Date Created",
        options: {
          filter: false,
          display: this.state.displayStatus[8],
          sortDirection: this.state.sort[8]
        }
      }
    ];

    const options = {
      filter: true,
      search: true,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      },
      onTableChange: async(action, tableState) => {
        switch (action) {
          case "changePage":
            this.handleSearch(tableState.rowsPerPage, tableState.page)
            break
          case "changeRowsPerPage":
            this.handleSearch(tableState.rowsPerPage, tableState.page)
            break
          case "propsUpdate":
            if (this.state.searchCheck) {
              this.setState({searchCheck: false})
              tableState.page = 0
              tableState.rowsPerPage = 10
            }
            break
          case "sort":
            tableState.page = 0;
            const condition = tableState.announceText.split(" ");
            const listColumn = this.state.sort;
            listColumn.forEach((value, index) => {
              let ascdesc;
              if (index === tableState.activeColumn) {
                if (condition[6] === "ascending") {
                  ascdesc = "asc";
                } else {
                  ascdesc = "desc";
                }
                this.state.sort[tableState.activeColumn] = ascdesc;
              } else {
                this.state.sort[index] = "none";
              }
            });
            await this.setState({
              orderby:
                tableState.columns[tableState.activeColumn].name ===
                "dateCreated"
                  ? `"dateCreated"`
                  : tableState.columns[tableState.activeColumn].name,
              activeColumn: tableState.activeColumn,
            });
            this.handleSearch(tableState.rowsPerPage, tableState.page, this.state.activeColumn, this.state.orderby);
            break;
          case "search":
            if (delay !== null) {
              clearTimeout(delay)
            }
            delay = setTimeout(async() => {
              let searchKeyword = tableState.searchText ? tableState.searchText : ''
              await this.handleKeyword(searchKeyword)
              tableState.searchText = this.state.keyword
            }, 3000)
          case "columnViewChange": {
            tableState.columns.forEach((column, index) => {
              if (column.display !== this.state.displayStatus[index]) {
                this.state.displayStatus[index] = column.display
              }
            })
          }
          default:
            break;
        }
      },
      serverSide: true,
      count: this.state.totalData,
      searchText: this.state.keyword
    };

    return (
      <div>
        <Grid item xs={12}>
          <div className={classes.content}>
            <Grid item xs={12}>
              <Button
                color="success"
                round
                onClick={() => this.handleClose("openAdd", true)}
              >
                <IconSettings /> Manage Category
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  {/* <FormControl variant="outlined">
                    <Select
                      value={this.state.selectedPeriode}
                      onChange={this.handleperiode}
                    >
                      <MenuItem value="1"> Daily </MenuItem>
                      <MenuItem value="7"> Weekly </MenuItem>
                      <MenuItem value="30"> Monthly </MenuItem>
                      <MenuItem value="90"> 3 Months </MenuItem>
                    </Select>
                  </FormControl> */}
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="Start Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.startDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.startDate,
                      onChange: this.handleStartDate
                    }}
                  />
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="End Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.endDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.endDate,
                      onChange: this.handleEndDate
                    }}
                  />
                  <Button 
                    color="primary"
                    variant="contained"
                    disabled={this.state.loader}
                    style={{marginRight: 20}}
                    onClick={() => this.handleSearchClick()}
                  >
                    Search
                  </Button>
                  <ExcelFile
                    element={
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={this.state.loader}
                      >
                        Download as .xslx
                      </Button>
                    }
                    filename={`${fileName}`}
                    fileExtension="xslx"
                  >
                    <ExcelSheet data={this.state.datatable} name="Sheet 1">
                      <ExcelColumn label="id" value="id" />
                      <ExcelColumn label="Ship Id" value="ship_id" />
                      <ExcelColumn label="Vessel Name" value="vessel_name" />
                      <ExcelColumn label="Destination" value="destination" />
                      <ExcelColumn
                        label="Prev Destination"
                        value="prev_destination"
                      />
                      <ExcelColumn
                        label="Reported Draught"
                        value="reported_draught"
                      />
                      <ExcelColumn
                        label="Prev Reported Draught"
                        value="prev_reported_draught"
                      />
                      <ExcelColumn label="Date Created" value="date_created" />
                      <ExcelColumn
                        label="Prev  Date Created"
                        value="prev_date_created"
                      />
                    </ExcelSheet>
                  </ExcelFile>
                </CardContent>
              </Card>
            </Grid>
            <br />
            <Grid item xs={12}>
              
            </Grid>
            <Grid item xs={12}>
              <MUIDataTable
                data={this.state.datatable}
                columns={columns}
                options={options}
              />
              <Dialog
                maxWidth={"md"}
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Manage Category
                </DialogTitle>
                <DialogContent>
                  <CatDraugh />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="danger"
                    round
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </div>
        </Grid>
      </div>
    );
  }
}

Draugh.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushPoiTarget: PropTypes.array,
  pushLoader: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget, pushLoader }
)(withStyles(styles)(Draugh)));
